import { UserService } from "./../pages/cadastro/usuario/services/user.service";
import {
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import PerfectScrollbar from "perfect-scrollbar";
import { VersionamentoService } from "./versionamento.service";
import { UserControllerService } from "../core/services/outros/user-controller.service";
import { ActivatedRoute, Router } from "@angular/router";
import { RoyaltiesService } from "../shared/services/royalties.service";
import packageJson from "../../../package.json"
import { RouteInfo, ROUTES_SIDEBAR } from "../core/types/sidebar-route-list";
import { ParameterService } from "../shared/services/parameter.service";
import { LocalStorageService } from "ngx-webstorage";
import { Variables } from "../core/utils/variables";
import { FeatureFlagService } from "../core/feature-flags/feature-flag.service";
import { NFSE_MODULE_ROLES, NfseRoles } from "../pages/nfse/models/nfse-roles";

declare const $: any;


@Component({
  selector: "app-sidebar-cmp",
  templateUrl: "sidebar.component.html",
  styleUrls: ["sidebar.component.css"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  readonly appVersion = packageJson.version
  user: any = "";
  firstName: any = "";
  royaltiesValue = "";
  isVisibile = false;
  suportContactPhoneNumber = "";
  private ROUTES = ROUTES_SIDEBAR

  public menuItems: any[] = [];
  ps: any;

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  constructor(
    private service: VersionamentoService,
    private userControllerService: UserControllerService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private royaltiesService: RoyaltiesService,
    private parameterService: ParameterService,
    private localStorage: LocalStorageService,
    private featureFlagService: FeatureFlagService
  ) {
    // this.service.getVersionamento().subscribe(
    //     //next => this.version = next;
    // )
  }



  ngOnInit() {
    this.menuItems = this.menuPermission();
    // as flags chegam depois do primeiro render do menu
    this.featureFlagService.flags$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.menuItems = this.menuPermission();
    });

    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemSidebar = <HTMLElement>(
        document.querySelector(".sidebar .sidebar-wrapper")
      );
      this.ps = new PerfectScrollbar(elemSidebar);
    }

    
    setTimeout(() => {
      if (localStorage.getItem("res")) {
        const user = localStorage.getItem("res");
        if(user){
          this.user = JSON.parse(user);
        }
        this.firstName = this.user.name.split(" ")[0];
        this.getEcvUser();
      }
    }, 1000);
    
    this.getSuportContactPhoneNumber();
  }

  onShowDetails(guid: string) {
    this.router.navigate([`/cadastro/usuario/visualizar/${guid}`], {
      relativeTo: this.route,
    });
  }

  onEdit(guid: string): void {
    this.router.navigate([`/cadastro/usuario/editar/${guid}`], {
      relativeTo: this.route,
    });
  }

  menuPermission(): RouteInfo[] {
    const roles: any = this.userControllerService.getRoles().roles;
    const isAdminRenova = this.isAdminRenova();

    let menu = [];

    // A flag vale mais que qualquer role: com NFS-e desligada só AdminRenova enxerga o menu.
    const canAccessNfseMenu = (role?: string) =>
      role === NfseRoles.NFSE &&
      (isAdminRenova ||
        (this.featureFlagService.isEnabled("NFSE") &&
          NFSE_MODULE_ROLES.some((r) => roles.includes(r))));

    const canAccess = (role?: string) =>
      role === NfseRoles.NFSE ? canAccessNfseMenu(role) : roles.includes(role);

    this.ROUTES.forEach((route) => {
      // Dashboard Financeiro: sem role Keycloak — só perfil AdminRenova.
      if (route.path === "/dashboard-financeiro") {
        if (isAdminRenova) {
          menu.push({ ...route, children: [] });
        }
        return;
      }

      if (canAccess(route.role)) {
        // cópia: menuPermission roda de novo quando as flags chegam e não pode esvaziar ROUTES_SIDEBAR
        const item = { ...route, children: [] };
        route.children?.forEach((child) => {
          if (canAccess(child.role)) {
            item.children.push(child);
          }
        });

        menu.push(item);
      }
    });

    if (isAdminRenova && !this.featureFlagService.isEnabled("NFSE")) {
      menu = menu.map((item) =>
        item.path === "/nfse"
          ? { ...item, title: `${item.title} (DESLIGADO)` }
          : item
      );
    }

    return menu;
  }

  private isAdminRenova(): boolean {
    const stored = localStorage.getItem("res");
    if (!stored) {
      return false;
    }
    const profiles = JSON.parse(stored)?.profiles;
    return Array.isArray(profiles) && profiles.includes("AdminRenova");
  }

  updatePS(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      this.ps.update();
    }
  }
  isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
      navigator.platform.toUpperCase().indexOf("IPAD") >= 0
    ) {
      bool = true;
    }
    return bool;
  }

  expandOrCollapseMenu(id) {
    let parent = document.getElementById(id + "-p");
    let child = document.getElementById(id);
    parent.ariaExpanded = parent.ariaExpanded === "true" ? "false" : "true";
    child.style.height =
      child.style.height === "0px" || child.style.height === "" ? "100%" : "0";
  }

  getEcvUser() {
    this.userService.getByID(this.user.id).subscribe((userRes) => {
      if (!userRes.ecVs || userRes.ecVs.length === 0) {
        return;
      }

      const ecvId = userRes.ecVs[0].id;

      this.royaltiesService.getByID(ecvId).subscribe((royaltiesRes) => {
        if (!royaltiesRes) {
          return;
        }

        this.royaltiesValue = royaltiesRes.balance;
        this.isVisibile = true;
      });
    });
  }

  getSuportContactPhoneNumber() {
    this.suportContactPhoneNumber = this.localStorage.retrieve(Variables.SUPORT_CONTACT)
    if(this.suportContactPhoneNumber) { return }

    this.parameterService
      .getSuportContactPhoneNumber()
      .subscribe((res) => {
        if (res) {
          this.suportContactPhoneNumber = res;
          this.localStorage.store(Variables.SUPORT_CONTACT, res)
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  logout() {
    this.userControllerService.logout();
  }
}
